<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-head"><a id="a5"></a>Contents</h1>
<h2 class="toc-1"><a id="page_v"></a><a href="#/xhtml/06_Mapslist#a25">List of Maps</a></h2>
<h2 class="toc-1"><a href="#/xhtml/07_Ack#a82">Acknowledgements for Illustrations and Maps</a></h2>
<h2 class="toc-1"><a href="#/xhtml/08_FM#a83">General Acknowledgements</a></h2>
<h2 class="toc-chap-top"><a href="#/xhtml/10_Chapter_1#a87"><span class="tocnum">Chapter 1</span> Small Beginnings</a></h2>
<h2 class="toc-chap"><a href="#/xhtml/11_Chapter_2#a91"><span class="tocnum">Chapter 2</span> Ambition is Stirred</a></h2>
<h2 class="toc-chap"><span href="#/xhtml/12_Chapter_3#a99" title="Link target outside of Sample"><span class="tocnum">Chapter 3</span> Townshend’s Regatta</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/13_Chapter_4#a102" title="Link target outside of Sample"><span class="tocnum">Chapter 4</span> The Repulse at Ctesiphon</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/14_Chapter_5#a110" title="Link target outside of Sample"><span class="tocnum">Chapter 5</span> The Medical Scandal</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/15_Chapter_5#a111" title="Link target outside of Sample"><span class="tocnum">Chapter 6</span> The Beginning of the Siege</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/16_Chapter_7#a122" title="Link target outside of Sample"><span class="tocnum">Chapter 7</span> Attempts at Relief</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/17_Chapter_8#a133" title="Link target outside of Sample"><span class="tocnum">Chapter 8</span> The Surrender of Kut</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/18_Chapter_9#a140" title="Link target outside of Sample"><span class="tocnum">Chapter 9</span> A Nightmare Journey</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/19_Chapter_10#a144" title="Link target outside of Sample"><span class="tocnum">Chapter 10</span> The Capture of Baghdad</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/20_Chapter_11#a154" title="Link target outside of Sample"><span class="tocnum">Chapter 11</span> Advances in the North</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/21_Chapter_12#a173" title="Link target outside of Sample"><span class="tocnum">Chapter 12</span> Dunsterville</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/22_Chapter_13#a177" title="Link target outside of Sample"><span class="tocnum">Chapter 13</span> The End of the Campaign</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/23_Chapter_14#a190" title="Link target outside of Sample"><span class="tocnum">Chapter 14</span> Consequences</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/24_Chapter_15#a191" title="Link target outside of Sample"><span class="tocnum">Chapter 15</span> Aftermath</span></h2>
<h2 class="toc-1_"><span href="#/xhtml/25_Biblio#a193" title="Link target outside of Sample">Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7b1f3476